<script>
import CustomersApi from "@/services/customers-api";
import SuppliersApi from "@/services/suppliers-api";
import BarChart from "./BarChart";
import OrdersApi from "@/services/orders-api";

export default {
    components: {    BarChart,
  },
    props: {
      firstDay:{
          type:String,
          default:null
      },
      lastDay:{
          type:String,
          default:null
      },
      isCurrentMonthProp:{
          type :Boolean,
          default:false
      },
    },
    mounted(){
        this.getCustomers()
        this.getSuppliers();
        this.getOrdersStatus()
        this.start=this.firstDay
        this.end=this.lastDay  
    } ,
    data(){
        return{
            start:this.firstDay,
            end:this.lastDay,
            isCurrentMonth:this.isCurrentMonthProp,
            customersList:[],
            selectedCustomer:null,
            selectedCountry:null,
            selectedCity:null,
            citiesList:[],
            countriesList:[],
            loading_sources:false,
            labels:[],
            data:[],
            colors:[],
            componentKey: 0,
            suppliersList:[],
            selectedSupplier:null,

        };
    },
      methods:{
        getCustomers(){
        CustomersApi.getCustomers(this.selectedCountry==null ? null : this.selectedCountry.id,this.selectedCity==null ? null : this.selectedCity.id).then(
            response => {
            this.customersList=response;
            }
        )
        },

        getSuppliers(){
        SuppliersApi.getAllSuppliers().then(
            response => {
            this.suppliersList=response;
            }
        )
    },

        statusToLabel(status) {
          switch(status) {
            case 1: return "Nouvelle";
            case 2: return "Confirmée";
            case 3: return "Livrée";
            case 4: return "Annulée";
            default: return '';
          }
        },

        statusToColor(status) {
          switch(status) {
            case 1: return '#f46a6a';
            case 2: return '#f1b44c';
            case 3: return '#34c38f'
            case 4: return '#74788d';
            default: return 'secondary';
          }
        },

      getOrdersStatus(){
        OrdersApi.getOrdersStatus(this.start,this.end,this.selectedCustomer==null ? null : this.selectedCustomer.id,this.selectedSupplier==null ? null : this.selectedSupplier.id,this.isCurrentMonth).then(

          (result)=>{
            if(result){
              this.loading_sources=false
              this.componentKey += 1;
              this.labels=[]
              this.colors=[]
              this.data=[]
              for(const i in result){
                this.labels.push(this.statusToLabel(result[i].status))
                this.data.push(result[i].count)
                this.colors.push(this.statusToColor(result[i].status))
              }
              this.loading_sources=true
              this.isCurrentMonth=false
            }
          }
        )
      },
    },
    watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getOrdersStatus()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getOrdersStatus()

          }
        },
        selectedCustomer: function(){
          this.getOrdersStatus()
        },

        selectedSupplier:function(){
            this.getOrdersStatus()
        }
    }
  
}
</script>
<template>
    <div class="clearfix m-4">
        <div class="row">
            <div class="col-11">
                <h4 class="card-title mb-2 font-size-18 font-weight-bold text-primary">Etat des commandes</h4>
            </div>
        </div>

              <div class="row pt-3">
                <div class="col-xl-6 pr-2 pt-2">
                   <b-form-group label="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="customersList" placeholder="Clients" label="name" v-model="selectedCustomer">
                        <span slot="no-options">Aucun client dans la liste</span>
                      </v-select>
                    </b-form-group>
                </div>
                 <div class="col-xl-6 pr-2 pt-2">
                    <b-form-group label="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="suppliersList" placeholder="Fournisseurs" label="name" v-model="selectedSupplier">
                        <span slot="no-options">Aucun Fournisseur dans la liste</span>
                      </v-select>
                    </b-form-group>
                </div>
              </div>
              <div class="row pt-3">
                    <div class="col-sm-6 col-xs-12 pr-2">

                      <b-form-group >
                        <b-form-datepicker
                          v-model="start"
                          locale="fr"
                          label-no-date-selected="Date Début"
                          dark
                          reset-button
                          close-button
                          label-reset-button="Réinitialiser"
                          label-close-button="Fermer"
                          dropright
                          hide-header
                        ></b-form-datepicker>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-xs-12 pr-2">
                      <b-form-group  >
                        <b-form-datepicker
                          v-model="end"
                          locale="fr"
                          label-no-date-selected="Date Fin"
                          dark
                          reset-button
                          close-button
                          label-reset-button="Réinitialiser"
                          label-close-button="Fermer"
                          dropright                         
                          hide-header
                        ></b-form-datepicker>
                      </b-form-group>
                      
                    </div>
                    
              </div>
  
      <div class="row text-center">
        <div class="col-sm-4">
          <h5 class="mb-0"></h5>
          <p class="text-muted"></p>
        </div>
        <div class="col-sm-4">

        </div>
        <div class="col-sm-4">
          <h5 class="mb-0"></h5>
          <p class="text-muted"></p>
        </div>
      </div>

      <BarChart v-if="loading_sources" :height="300" :labels.sync="this.labels" :data.sync="this.data" :colors.sync="this.colors" :key="componentKey" />

    </div>
</template>